module.exports = __webpack_public_path__ + "static/img/isTop.e370e05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/articleManage/isTop.png
// module id = PaUJ
// module chunks = 1